export default __webpack_public_path__ + "static/verticals-ed386d41ab2b0e3bd2b5f2dbb8f5176f.png";